module.exports = __webpack_public_path__ + "img/video-bg.29a75dc5.png";